const STORAGE_PREFIX = "tulocalmx-zone-insight";
const CACHE_VERSION = "v4";

const normalizeCacheValue = (value = "") =>
  value
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();

export const getZoneInsightCacheKey = (propertyId, business = "") =>
  `${STORAGE_PREFIX}:${CACHE_VERSION}:${propertyId}:${normalizeCacheValue(business)}`;

export const readZoneInsightCache = (propertyId, business = "") => {
  if (typeof window === "undefined") return null;

  try {
    const stored = window.localStorage.getItem(
      getZoneInsightCacheKey(propertyId, business)
    );

    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    return null;
  }
};

export const writeZoneInsightCache = (propertyId, business = "", analysis) => {
  if (typeof window === "undefined" || !analysis) return;

  try {
    window.localStorage.setItem(
      getZoneInsightCacheKey(propertyId, business),
      JSON.stringify(analysis)
    );
  } catch (error) {
    // Cache only; ignore storage failures.
  }
};
